import React from "react";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { GT_BANKS, BANK_ACCOUNT_TYPES } from "../lib/banks";

export const DEST_TYPES = [
  { v: "propia", label: "Cuenta propia del beneficiario" },
  { v: "tercero", label: "Cuenta de tercero" },
  { v: "ach", label: "Cuenta ACH" },
  { v: "internacional", label: "Cuenta internacional" },
];

export const destLabel = (v) => (DEST_TYPES.find((d) => d.v === v)?.label || "");

// Bloque reutilizable para capturar el destino de una salida por transferencia.
export function TransferDestination({ value, onChange, holderLabel = "Titular de la cuenta" }) {
  const v = value || {};
  return (
    <div className="space-y-2 border border-border rounded-sm p-3" data-testid="transfer-dest">
      <p className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Destino de la transferencia</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label className="text-[10px] uppercase tracking-widest font-bold">Tipo de destino</Label>
          <Select value={v.dest_type || "propia"} onValueChange={(x) => onChange({ dest_type: x })}>
            <SelectTrigger className="rounded-sm h-9 text-xs" data-testid="dest-type"><SelectValue /></SelectTrigger>
            <SelectContent>{DEST_TYPES.map((d) => <SelectItem key={d.v} value={d.v}>{d.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label className="text-[10px] uppercase tracking-widest font-bold">{holderLabel}</Label>
          <Input className="rounded-sm h-9 text-xs" value={v.dest_holder || ""} onChange={(e) => onChange({ dest_holder: e.target.value })} placeholder="Nombre del titular" data-testid="dest-holder" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-[10px] uppercase tracking-widest font-bold">Banco destino</Label>
          <Select value={v.dest_bank === "Otro" || (v.dest_bank && !GT_BANKS.includes(v.dest_bank)) ? "Otro" : (v.dest_bank || "")} onValueChange={(x) => onChange({ dest_bank: x })}>
            <SelectTrigger className="rounded-sm h-9 text-xs" data-testid="dest-bank"><SelectValue placeholder="Selecciona banco" /></SelectTrigger>
            <SelectContent>{GT_BANKS.map((b) => <SelectItem key={b} value={b}>{b}</SelectItem>)}</SelectContent>
          </Select>
          {(v.dest_bank === "Otro" || (v.dest_bank && !GT_BANKS.includes(v.dest_bank))) && <Input className="rounded-sm h-9 text-xs mt-1" value={v.dest_bank === "Otro" ? "" : v.dest_bank} onChange={(e) => onChange({ dest_bank: e.target.value })} placeholder="Nombre del banco" data-testid="dest-bank-other" />}
        </div>
        <div className="space-y-1.5">
          <Label className="text-[10px] uppercase tracking-widest font-bold">Tipo de cuenta</Label>
          <Select value={v.dest_account_type || ""} onValueChange={(x) => onChange({ dest_account_type: x })}>
            <SelectTrigger className="rounded-sm h-9 text-xs" data-testid="dest-account-type"><SelectValue placeholder="Monetaria / Ahorro" /></SelectTrigger>
            <SelectContent>{BANK_ACCOUNT_TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label className="text-[10px] uppercase tracking-widest font-bold">No. de cuenta</Label>
          <Input className="rounded-sm h-9 text-xs" value={v.dest_account || ""} onChange={(e) => onChange({ dest_account: e.target.value })} placeholder="No. de cuenta destino" data-testid="dest-account" />
        </div>
      </div>
    </div>
  );
}

export default TransferDestination;
